import { Directive, HostListener, Input } from '@angular/core';
import { DropdownComponent } from './dropdown.component';

@Directive({
  selector: '[psUiDropdownToggleFor]',
})
export class DropdownToggleDirective {
  @Input('psUiDropdownToggleFor') dropdown?: DropdownComponent;

  constructor() {}

  @HostListener('click')
  toggleDropdown() {
    this.dropdown?.toggle();
  }
}
